// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__114tT","range":"MonthRangeSwitch_range__1577P","disabled":"MonthRangeSwitch_disabled__1tI94"};